var TvShopEntertainmentPack = /** @class */ (function () {
    function TvShopEntertainmentPack() {
    }
    TvShopEntertainmentPack.createTvShopEntertainmentPack = function (packVariablesWithoutMethods) {
        var result = new TvShopEntertainmentPack();
        result.omapiId = packVariablesWithoutMethods.omapiId;
        result.priceDetail = packVariablesWithoutMethods.priceDetail;
        result.isHidden = packVariablesWithoutMethods.isHidden;
        result.subscribed = packVariablesWithoutMethods.subscribed;
        result.isUpgrade = packVariablesWithoutMethods.isUpgrade;
        result.isDowngrade = packVariablesWithoutMethods.isDowngrade;
        result.isTrial = packVariablesWithoutMethods.isTrial;
        result.hasTrial = packVariablesWithoutMethods.hasTrial;
        result.isDayPass = packVariablesWithoutMethods.isDayPass;
        result.omapiCharacteristics = packVariablesWithoutMethods.omapiCharacteristics;
        result.hasDayPass = packVariablesWithoutMethods.hasDayPass;
        result.endDate = packVariablesWithoutMethods.endDate;
        result.collectionBlock = packVariablesWithoutMethods.collectionBlock;
        result.downgradeUpgradeOmapiIds = packVariablesWithoutMethods.downgradeUpgradeOmapiIds;
        return result;
    };
    TvShopEntertainmentPack.prototype.isOrderable = function () {
        return !this.subscribed && (!this.isDowngrade || this.isDayPass || this.isTrial);
    };
    return TvShopEntertainmentPack;
}());
export { TvShopEntertainmentPack };
